// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2c48fa29","513":"81ae2325","703":"55db3e0a"}[chunkId] + ".chunk.js";
};